
import { Context } from '@nuxt/types'
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import BlogAcfBlocks from '~/components/blog/BlogAcfBlocks.vue'
import { DiagramStoreActions } from '~/domain/interfaces'
import { PageData } from '~/domain/interfaces/PageDataTypes'

export default defineComponent({
  name: 'dynamic-landing-page',
  components: { BlogAcfBlocks },
  extends: MachinationsLightPage,
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      meta: [...pageHead?.meta],
    }
  },
  async asyncData(context: Context) {
    const { store, params, error } = context
    const slug = params.slug
    if (slug === '/') {
      return
    }
    let pageExists: PageData | null = null
    try {
      pageExists = await store.dispatch('wp/fetchPageBySlug', {
        context,
        slug,
      })
      if (!pageExists) {
        error({ statusCode: 404, message: 'Page not found' })
      } else {
        await store.dispatch('common/setupPageLight', { context })
        if (pageExists?.metadata?.blocks?.[0]?.includes('joincommunity')) {
          await store.dispatch(
            DiagramStoreActions.GET_DIAGRAMS_OF_THE_MONTH,
            context
          )
        }
        return pageExists
      }
    } catch (e) {
      error({ statusCode: 404, message: 'Page not found' })
    }
    return pageExists
  },
  mounted() {
    const slug = this.$route.params.slug
  },
})
